export default "__VITE_ASSET__CxJ4nOGM__"